import * as React from "react";
import PropTypes from "prop-types";
import Backbone from "backbone";
import CommonControlWrapper from "nexia_mobile/components/Controls/wrappers/CommonControlWrapper";
import DeviceControlButton from "nexia_mobile/components/Controls/DeviceControlButton";
import { history } from "nexia_mobile/history";

const MultiCamera = ({ model, isDetailed }) => (
  <CommonControlWrapper isDetailed={isDetailed}>
    <DeviceControlButton
      buttonLabel="Show Videos"
      onTap={() => {
        history.push("/app/multi-video-feed", { group: model });
      }}
      disabled={!model.getGroupMembers().any((child) => child.isConnected())}
    />
  </CommonControlWrapper>
);

MultiCamera.propTypes = {
  model: PropTypes.instanceOf(Backbone.Model).isRequired,
  isDetailed: PropTypes.bool.isRequired,
};

export default MultiCamera;



// WEBPACK FOOTER //
// ./src/components/Controls/MultiCamera.jsx